import Section from "../Section";
export default class InteractiveMenu extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

  }
}